import React from 'react';
import { ArrowRight, MessageSquare, Zap, TrendingUp, Users } from 'lucide-react';

export default function AutomateSection() {
  return (
    <section className="py-24 bg-black text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-30" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, rgba(34,197,94,0.15) 0%, transparent 40%), radial-gradient(circle at 80% 70%, rgba(34,197,94,0.10) 0%, transparent 40%)' }} />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div className="fade-in">
          <div className="text-sm font-bold tracking-[0.25em] uppercase text-[#22c55e] mb-4">Keep Everything In One Place</div>
          <h2 className="text-4xl md:text-5xl font-black leading-tight mb-6">
            Convert Leads.<br />
            <span className="text-[#22c55e]">Expand</span> Business.
          </h2>
          <p className="text-lg text-neutral-300 leading-relaxed mb-6">
            Simplify communication with customers and leads using Xxpand&apos;s powerful business automation tools.
          </p>
          <p className="text-neutral-400 leading-relaxed mb-8">
            Reach your audience wherever they are, send text messages, request reviews, respond to Facebook & Google messages, connect with website visitors, collect payments, and even market to leads &mdash; all from one easy-to-use app.
          </p>

          <button className="cta-btn group inline-flex items-center gap-2 px-8 py-4 bg-[#22c55e] text-black rounded-full font-bold text-[15px]">
            Start 14 Day Free Trial
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
          <div className="mt-3 text-sm text-neutral-500 italic">No credit card required</div>
        </div>

        <div className="grid grid-cols-2 gap-4 fade-in">
          {[
            { icon: MessageSquare, label: 'Unified Inbox', val: '12,450+', sub: 'messages/day' },
            { icon: Zap, label: 'Automations Run', val: '250K+', sub: 'this month' },
            { icon: TrendingUp, label: 'Revenue Growth', val: '+38%', sub: 'avg. YoY' },
            { icon: Users, label: 'Active Users', val: '80+', sub: 'businesses' },
          ].map((s, i) => (
            <div key={s.label} className="rounded-2xl bg-neutral-900 border border-neutral-800 p-6 hover:border-[#22c55e] transition-all duration-300 hover:-translate-y-1" style={{ transitionDelay: `${i * 60}ms` }}>
              <div className="w-12 h-12 rounded-xl bg-[#22c55e] flex items-center justify-center mb-4">
                <s.icon className="w-6 h-6 text-black" strokeWidth={2.2} />
              </div>
              <div className="text-3xl font-black text-white mb-1">{s.val}</div>
              <div className="text-[13px] font-semibold text-[#22c55e] mb-0.5">{s.label}</div>
              <div className="text-xs text-neutral-500">{s.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
